import React from "react";
import { useSelector } from "react-redux";
import RelatedBlog from "./RelatedBlog";

const RelatedBlogs = () => {
  const {blogs} = useSelector(state => state.relatedBlogs);
  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">
        
        {/* <!-- related post  --> */}
        {
          blogs?.map(blog => <RelatedBlog key={blog.id} blog={blog}></RelatedBlog>)
        }
        
      </div>
    </aside>
  );
};

export default RelatedBlogs;
